import {
  CONVENIENCE_DOOR_TABLE_KEY,
  CONVENIENCE_TABLE_KEY,
} from 'constants/tableQueryKeys'
import { ConvenienceTable } from './ConvenienceTable/ConvenienceTable'
import { StandardSummaryResponse } from 'models/paginated-response'
import { ConvenienceDoorTable } from '../ConvenienceDoors/ConvenienceDoorsTable/ConvenienceDoorsTable'
import { useOpportunitiesContext } from 'pages/app/opportunities/opportunities-context'

export function ConvenienceChainDoorTable({
  pageParamName,
  setConvenienceCount,
}: {
  pageParamName: string
  setConvenienceCount: (count: StandardSummaryResponse) => void
}) {
  const { selectedTag } = useOpportunitiesContext()

  return (
    <>
      {selectedTag === 'fb-companies' ? (
        <ConvenienceTable
          pageParamName={`${pageParamName}-chain-page`}
          tableKey={CONVENIENCE_TABLE_KEY}
          setTotalRowsCount={setConvenienceCount}
        />
      ) : null}

      {selectedTag === 'fb-locations' ? (
        <ConvenienceDoorTable
          pageParamName={`${pageParamName}-door-page`}
          tableKey={CONVENIENCE_DOOR_TABLE_KEY}
          setTotalRowsCount={(count) =>
            setConvenienceCount({
              // Since they share the same component for showing doors and chains count
              // the value is swapped for the doors table, where the alt_count is the chains count
              count: count.alt_count,
              alt_count: count.count,
            })
          }
        />
      ) : null}
    </>
  )
}
